<app-widget-toolbar [widgetConfig]="widgetConfig"></app-widget-toolbar>
<div *ngIf="!measurements || measurements.lineSeries.length === 0 && !genericWidgetService.loading" class="no-data">
    <p>Brak danych z tego okresu!</p></div>
<!--<div id="chartContainer" class="line-chart"></div>-->
<div id="{{chartId}}" (click)="onClick($event)" class="line-chart"></div>
<app-mat-spinner-overlay *ngIf="genericWidgetService.loading" overlay="true"></app-mat-spinner-overlay>
